import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client/core'
import { setContext } from '@apollo/client/link/context'
import { provideApolloClient } from '@vue/apollo-composable'

let GRAPHQL_URL = process.env.VUE_APP_GRAPHQL_URL || 'http://localhost:8000/graphql'

function makeLink(url) {
  return createHttpLink({ uri: url })
}

function makeAuthLink() {
  return setContext((_, { headers }) => {
    const token = localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token')
    const type = localStorage.getItem('token_type') || sessionStorage.getItem('token_type') || 'bearer'
    const slug = window.location.pathname.match(/^\/room\/([^/]+)/)?.[1]
    const roomToken = slug ? sessionStorage.getItem(`room_unlock_${slug}`) : null
    const csrf = getCookie('csrf_token') || localStorage.getItem('csrf_token')
    return {
      headers: {
        ...headers,
        ...(token ? { Authorization: `${type} ${token}` } : {}),
        ...(roomToken ? { 'X-Room-Token': roomToken } : {}),
        ...(csrf ? { 'X-CSRF-Token': csrf } : {})
      }
    }
  })
}

let client = new ApolloClient({
  link: makeAuthLink().concat(makeLink(GRAPHQL_URL)),
  cache: new InMemoryCache()
})

provideApolloClient(client)

export function getApolloClient() { return client }
export function getGraphqlUrl() { return GRAPHQL_URL }
export function setGraphqlUrl(url) {
  GRAPHQL_URL = url
  client = new ApolloClient({
    link: makeAuthLink().concat(makeLink(GRAPHQL_URL)),
    cache: new InMemoryCache()
  })
  provideApolloClient(client)
}

function getCookie(name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
}
